export class VisibilityObserver {
    /**
     * Creates (and updates) visibility map of elements, so that it can be quickly checked
     * if element is currently visible by human eyes.
     *
     * start() method needs to be called for VisibilityObserver to work
     *
     * @param {HTMLElement[]} elems
     * @param {Object} [options] - IntersectionObserver options.
     */
    constructor(elems, options) {
        this.elems = elems;
        this.elemsVisibilityMap = {};
        this.started = false;

        elems.forEach((elem, observeIndex) => {
            elem.dataset.observeIndex = observeIndex;
            this.elemsVisibilityMap[observeIndex] = true;
        });

        this.observer = new IntersectionObserver(entries => this.#setVisibility(entries), options);
    }

    start() {
        this.started = true;
        this.elems.forEach(elem => this.observer.observe(elem));
    }

    end() {
        this.observer.disconnect();
    }

    // Sets if element is visible by human eyes
    #setVisibility(entries) {
        for (const { target, isIntersecting } of entries) {
            this.elemsVisibilityMap[target.dataset.observeIndex] = isIntersecting;
        }
    }
}
